class CodeBlockHintService {
    isPlantUml(hint: string): boolean {
        return hint.trim().toLowerCase() === 'plantuml'
    }
}

export const codeBlockHintService = new CodeBlockHintService()